// meals/{mealId} — see src/Auth/host/createListing.js and editListing.js.
const { MealStatus } = require('../status/mealStatus');

// Fields: hostId, title, description, cuisineType, menu, dateTime,
// maxGuests, currentGuests, neighborhood, dietaryAccommodations,
// alcoholOption, bookingCutoff, bookingCutoffTime, specialNotes, photoUrl,
// status, createdAt.
//
// street, unitNumber, city, state, zipCode live on the private subdoc
// meals/{mealId}/private/address (F-06) -- host-readable directly via
// rules, guest-readable only through the getMealAddress callable, which
// checks for a confirmed booking server-side.

const hasCapacity = (meal) => (meal.currentGuests || 0) < (meal.maxGuests || 0);

const isBookable = (meal) => meal.status === MealStatus.ACTIVE && hasCapacity(meal);

module.exports = { hasCapacity, isBookable };
